import { render, staticRenderFns } from "./BankExtractImportItems.vue?vue&type=template&id=6a9c582d&scoped=true&"
import script from "./BankExtractImportItems.vue?vue&type=script&lang=ts&"
export * from "./BankExtractImportItems.vue?vue&type=script&lang=ts&"
import style0 from "./BankExtractImportItems.vue?vue&type=style&index=0&id=6a9c582d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9c582d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VExpandTransition,VSimpleTable})
